import { PersonaSize, PersonaPresence, IPersonaProps } from '@fluentui/react';
import { TimeUser } from '../api/generated/data-contracts';

export const mapUserToPersona = (user: TimeUser) => {
    return createUserPersonaFromUser(user);
};

export const createUserPersonaFromUser = (user: TimeUser, props: IPersonaProps = {}) => {
    return {
        imageInitials: user.name?.substring(0, 1) + (user.surname ? user.surname.substring(0, 1) : ''),
        text: user.name,
        secondaryText: user.userNumber ?? user.jobTitle ?? '',
        showSecondaryText: true,
        size: PersonaSize.size48,
        presence: PersonaPresence.none,
        imageAlt: user.name + ', ' + user.jobTitle,
        itemID: user.id,
        ...props,
    } as IPersonaProps;
};
